<template>
    <div class="flex flex-col gap-4 h-full overflow-y-auto pt-20 md:pt-20 xl:pt-8 p-4 md:p-8">
        <div class="flex flex-col w-full  gap-4">
            <div class="flex flex-col gap-1">
                <h1 class="text-xl font-modulus-semibold font-[500]">{{ $t("dashboard.auto.resumen_este_mes") }}</h1>
                <p class="text-sm font-modulus font-[300]">{{ $t("dashboard.auto.muestra_a_manera_de_resumen_todo_lo_que_se_ha_re") }}</p>
            </div>

            <div class="grid gap-4 sm:gap-5 lg:gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                <div class="border rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow">
                    <div class="pb-3">
                        <div class="flex items-center justify-between">
                            <div class="text-lg font-medium text-muted-foreground text-eblack-800">{{ $t("dashboard.auto.comisiones_por_cobrar") }}</div>
                                <div class="flex h-10 w-10 items-center justify-center rounded-full bg-rajah-100">
                                    <IconClock class="h-5 w-5 text-rajah-600" />
                                </div>
                            </div>
                        </div>
                    <div>
                        <div class="text-3xl font-bold text-foreground text-eblack-900">{{ monthSummary.pendingCommissions ?? 0 }}</div>
                        <p class="text-xs text-muted-foreground mt-1 text-eblack-500">{{ $t("dashboard.auto.sin_cambios_este_mes") }}</p>
                    </div>
                </div>

                <div class="border rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow">
                    <div class="pb-3">
                        <div class="flex items-center justify-between">
                            <div class="text-lg font-medium text-muted-foreground text-eblack-800">{{ $t("dashboard.auto.itinerarios_por_cobrar") }}</div>
                                <div class="flex h-10 w-10 items-center justify-center rounded-full bg-eblue-100">
                                    <IconCalendar class="h-5 w-5 text-eblue-600" />
                                </div>
                            </div>
                        </div>
                    <div>
                        <div class="text-3xl font-bold text-foreground text-eblack-900">{{ monthSummary.pendingBookings ?? 0 }}</div>
                        <p class="text-xs text-muted-foreground mt-1 text-eblack-500">{{ $t("dashboard.auto.sin_cambios_este_mes") }}</p>
                    </div>
                </div>

                <div class="border rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow">
                    <div class="pb-3">
                        <div class="flex items-center justify-between">
                            <div class="text-lg font-medium text-muted-foreground text-eblack-800">{{ $t("dashboard.auto.ingreso_realizado") }}</div>
                                <div class="flex h-10 w-10 items-center justify-center rounded-full bg-egreen-100">
                                    <IconCash class="h-5 w-5 text-egreen-600" />
                                </div>
                            </div>
                        </div>
                    <div>
                        <div class="text-3xl font-bold text-foreground text-eblack-900">${{ monthSummary.incomes ?? 0 }}</div>
                        <p class="text-xs text-muted-foreground mt-1 text-eblack-500">{{ $t("dashboard.auto.sin_cambios_este_mes") }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid gap-4 sm:gap-5 lg:gap-6 grid-cols-1 lg:grid-cols-3">
            <div class="lg:col-span-2 border shadow-sm p-4 rounded-2xl">
                <div>
                    <div class="flex items-center justify-between">
                        <div>
                            <div class="text-lg font-semibold text-eblack-800">{{ $t("dashboard.auto.usuarios_por_mes") }}</div>
                            <p class="mt-1 text-eblack-500 text-sm">{{ $t("dashboard.auto.actividad_de_usuarios_durante_el_ano") }}</p>
                        </div>
                        
                            <DashboardDropdown :options="yearsDropdownOptions"/>
                        </div>
                    </div>
                <div>
                    <DashboardChart :data="userChartData"/>
                </div>
            </div>

            <div class="border shadow-sm p-4 rounded-2xl">
              <div>
                <div class="flex items-center justify-between">
                    <h3 h3 class="text-lg font-semibold text-eblack-800">{{ $t("dashboard.auto.resumen_general") }}</h3>
                    <DashboardDropdown :options="yearsDropdownOptions"/>
                </div>
                <p class="mt-1 text-eblack-500 text-sm">{{ $t("dashboard.auto.muestra_a_manera_de_resumen_todo_lo_que_se_ha_re_i7ya5") }}</p>
              </div>
              <div class="space-y-6 mt-4">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-purple-100">
                      <IconUsers class="h-4 w-4 text-purple-600" />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-foreground">{{ $t("dashboard.auto.concierges") }}</p>
                      <p class="text-xs text-muted-foreground">{{ $t("dashboard.auto.total_registrados") }}</p>
                    </div>
                  </div>
                  <span class="text-2xl font-bold text-foreground">{{ generalSummary.conciergeUsers }}</span>
                </div>

                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-100">
                      <IconUsers class="h-4 w-4 text-indigo-600" />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-foreground">{{ $t("dashboard.auto.proveedores") }}</p>
                      <p class="text-xs text-muted-foreground">{{ $t("dashboard.auto.total_registrados") }}</p>
                    </div>
                  </div>
                  <span class="text-2xl font-bold text-foreground">{{ generalSummary.providerUsers ?? 0 }}</span>
                </div>

        
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-eblue-100">
                      <IconMapPin class="h-4 w-4 text-eblue-600" />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-foreground">{{ $t("dashboard.auto.itinerarios") }}</p>
                      <p class="text-xs text-muted-foreground">{{ $t("dashboard.auto.total_generados") }}</p>
                    </div>
                  </div>
                  <span class="text-2xl font-bold text-foreground">{{ generalSummary.itinerariesGenerated }}</span>
                </div>

             
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-egreen-100">
                      <IconCircleCheck class="h-4 w-4 text-egreen-600" />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-foreground">{{ $t("dashboard.auto.reservas") }}</p>
                      <p class="text-xs text-muted-foreground">{{ $t("dashboard.auto.total_generadas") }}</p>
                    </div>
                  </div>
                  <span class="text-2xl font-bold text-foreground">{{ generalSummary.bookingsGenerated }}</span>
                </div>

             
                <div class="flex items-center justify-between pt-4 border-t border-border">
                  <div class="flex items-center gap-3">
                    <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-100">
                      <IconReceipt class="h-4 w-4 text-orange-600" />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-foreground">{{ $t("dashboard.auto.ingreso_realizado") }}</p>
                      <p class="text-xs text-muted-foreground">{{ $t("dashboard.auto.pagado_total") }}</p>
                    </div>
                  </div>
                  <span class="text-2xl font-bold text-foreground">${{ generalSummary.totalTransactions }}</span>
                </div>
              </div>
            </div>
        </div>

        <div class="grid gap-4 sm:gap-5 lg:gap-6 grid-cols-1 lg:grid-cols-3">
            <div class="lg:col-span-2 border shadow-sm p-4 rounded-2xl">
                <div>
                    <div class="flex items-center justify-between">
                        <div>
                            <div class="text-lg font-semibold text-eblack-800">{{ $t("dashboard.auto.servicios_pagados") }}</div>
                            <p class="mt-1 text-eblack-500 text-sm">{{ $t("dashboard.auto.actividad_de_servicios_pagados_durante_el_ano") }}</p>
                        </div>
                        
                            <DashboardDropdown :options="yearsDropdownOptions"/>
                        </div>
                    </div>
                <div>
                    <template v-if="chartData && chartData.datasets && chartData.datasets.length > 0">
                        <DashboardChart 
                        :data="chartData"/>
                    </template>

                    <div v-else class="flex flex-col items-center justify-center py-12">
                        <div class="flex h-16 w-16 items-center justify-center rounded-full bg-eblack-100 mb-4">
                            <IconChartBarPopular class="h-8 w-8 text-eblack-400" />
                        </div>
                        <p class="text-sm text-muted-foreground">{{ $t("dashboard.auto.no_services") }}</p>
                    </div>
                </div>
            </div>

            <div class="border shadow-sm p-4 rounded-2xl">
                <div>
                    <div class="flex items-center justify-between">
                        <h3 h3 class="text-lg font-semibold text-eblack-800">{{ $t("dashboard.auto.pending_payment_itineraries") }}</h3>
                    </div>
                    <p class="mt-1 text-eblack-500 text-sm">
                        {{ $t("dashboard.auto.pending_payment_itineraries_description") }}
                    </p>
                </div>

                <div>
                    <template v-if="approvedItineraries.length > 0">
                        <DashboardChart 
                        :data="chartData"/>
                    </template>

                    <div v-else class="flex flex-col items-center justify-center py-12">
                        <div class="flex h-16 w-16 items-center justify-center rounded-full bg-eblack-100 mb-4">
                            <IconCalendar class="h-8 w-8 text-eblack-400" />
                        </div>
                        <p class="text-sm text-muted-foreground">{{ $t("dashboard.auto.no_pending_payment_itineraries") }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid gap-4 sm:gap-5 lg:gap-6 grid-cols-1 lg:grid-cols-2">
            <div class="border shadow-sm p-4 rounded-2xl">
              <div>
                <div>
                      <h2 class="text-lg font-semibold text-eblack-800">{{ $t("dashboard.auto.concierge") }}</h2>
                  <p class="mt-1 text-eblack-500 text-sm">
                        {{ $t("dashboard.auto.concierge_payables_description") }}
                  </p>
                </div>
              </div>
              <div>
                <div class="flex flex-col items-center justify-center py-12">
                  <div class="flex h-16 w-16 items-center justify-center rounded-full bg-egreen-100 mb-4">
                    <IconCircleCheck class="h-8 w-8 text-egreen-600" />
                  </div>
                      <p class="text-sm text-muted-foreground">{{ $t("dashboard.auto.payments_up_to_date") }}</p>
                </div>
              </div>
            </div>

            <div class="border shadow-sm p-4 rounded-2xl">
              <div>
                <div>
                      <h2 class="text-lg font-semibold text-eblack-800">{{ $t("dashboard.auto.proveedores") }}</h2>
                  <p class="mt-1 text-eblack-500 text-sm">
                        {{ $t("dashboard.auto.providers_payables_description") }}
                  </p>
                </div>
              </div>
              <div>
                <div class="flex flex-col items-center justify-center py-12">
                  <div class="flex h-16 w-16 items-center justify-center rounded-full bg-egreen-100 mb-4">
                    <IconCircleCheck class="h-8 w-8 text-egreen-600" />
                  </div>
                      <p class="text-sm text-muted-foreground">{{ $t("dashboard.auto.payments_up_to_date") }}</p>
                </div>
              </div>
            </div>
        </div>

<!-- 
        <div class="grid grid-cols-1 mt-4 gap-4">
            <div class="">
                <div class="w-full flex flex-col p-4 gap-4">
                    <div class="flex flex-col gap-1">
                        <h1 class="text-lg">Itinerarios</h1>
                        <p class="text-sm">Lista de itinerarios que están pendientes de pago</p>
                    </div>

                    <div class="border rounded-md bg-white p-4 flex flex-col gap-4">
                        <div class="flex flex-col w-full border rounded-lg p-2" v-for="itinerary in approvedItineraries" :key="itinerary.id"> 
                            <div class="flex justify-between items-center" >
                                <div class="flex flex-col gap-1">
                                    <h1>{{itinerary.code}}</h1>
                                    <div class="flex flex-col gap-2">
                                        <span class="text-md font-semibold">${{ itinerary.total }}</span>
                                    </div>
                                </div>
                                
                                <span class="text-sm">APPROVED</span>
                            </div>
                        </div>
                        <div class="flex flex-col w-full  rounded-lg p-2" v-if="approvedItineraries.length == 0"> 
                            <div class="flex justify-center items-center" >
                                <span class="text-sm text-gray-500">No hay itinerarios pendientes de pago</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="" hidden>
                <div class="w-full flex flex-col p-4 gap-4">
                    <div class="flex flex-col gap-1">
                        <h1 class="text-lg">Usuarios</h1>
                        <p class="text-sm">Usuarios que están próximos a pagar</p>
                    </div>

                    <div class="border rounded-md bg-white p-4">

                    </div>

                    <div class="flex flex-col w-full  rounded-lg p-2" v-if="approvedItineraries.length == 0"> 
                        <div class="flex justify-center items-center" >
                            <span class="text-sm text-gray-500">No hay usuarios próximos a pago</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 mt-4 gap-4">
            <div class="">
                <div class="w-full flex flex-col p-4 gap-4">
                    <div class="flex flex-col gap-1">
                        <h1 class="text-lg">Concierge</h1>
                        <p class="text-sm">Lista de concierges a los que se le tiene que pagar</p>
                    </div>

                    <div class="border rounded-md bg-white p-4 flex flex-col gap-4">
                        <div class="flex flex-col w-full border rounded-lg p-2" v-for="(concierge,index) in pendingPaidConcierge" :key="index"> 
                            <div class="flex justify-between items-center" >
                                <div class="flex flex-col gap-1">
                                    <h1>{{ concierge.company_name }} ({{concierge.code}})</h1>
                                    <div class="flex flex-col gap-2">
                                        <span class="text-md font-semibold">${{ concierge.commission_amount }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="flex flex-col w-full  rounded-lg p-2" v-if="pendingPaidConcierge.length == 0"> 
                            <div class="flex justify-center items-center" >
                                <span class="text-sm text-gray-500">Todos los pagos están al día</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="">
                <div class="w-full flex flex-col p-4 gap-4">
                    <div class="flex flex-col gap-1">
                        <h1 class="text-lg">Proveedores</h1>
                        <p class="text-sm">Lista de concierges a los que se le tiene que pagar</p>
                    </div>

                    <div class="border rounded-md bg-white p-4 flex flex-col gap-4">
                        <div class="flex flex-col w-full border rounded-lg p-2" v-for="(provider,index) in pendingPaidProvider" :key="index"> 
                            <div class="flex justify-between items-center" >
                                <div class="flex flex-col gap-1">
                                    <h1>{{ provider.name }} ({{provider.code}})</h1>
                                    <div class="flex flex-col gap-2">
                                        <span class="text-md font-semibold">${{ provider.total_pending }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div class="flex flex-col w-full  rounded-lg p-2" v-if="pendingPaidProvider.length == 0"> 
                            <div class="flex justify-center items-center" >
                                <span class="text-sm text-gray-500">Todos los pagos están al día</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
</template>

<script>
import DashboardChart from './DashboardChart.vue';
import dashboardRequests from '@/services/admin/dashboard-service';
import DashboardDropdown from './DashboardDropdown.vue';
import { IconCalendar, IconCash, IconChartBarPopular, IconCircleCheck, IconClock, IconMapPin, IconReceipt, IconUsers } from '@tabler/icons-vue';

export default {
    name:"AdminDashboard",
    data(){
        return {
            showDetails: true,
            itineraries: [],
            monthSummary: {
                pendingCommissions:0,
                pendingBookings:0,
                incomes:0,
                paidIncomes:0,
                pendingIncomes:0,
            },
            generalSummary:{
                conciergeUsers:0,
                providerUsers:0,
                itinerariesGenerated:0,
                bookingsGenerated:0,
                totalTransactions:0
            },
            pendingPaidConcierge: [],
            pendingPaidProvider: [],
            approvedItineraries: [],
            currentYear: new Date().getFullYear(),
            userId:"",
            userChartData:[
                {
                    label: '',
                    backgroundColor: '#F3764A',
                    data: []
                },
            ],
            chartData:[
            ],
            usersByMonth:[],
            incomesServices:[],
            yearsDropdownOptions: {
                values:[2025,2026,2027],
                default: new Date().getFullYear()
            }
        }
    },
    computed: {
        currentLocale() {
            const locale = this.$i18n?.locale;
            return typeof locale === "string" ? locale : locale?.value || "es";
        },
    },
    components:{
        DashboardChart,
        DashboardDropdown,
        IconClock,
        IconCalendar,
        IconCash,
        IconUsers,
        IconMapPin,
        IconCircleCheck,
        IconReceipt,
        IconChartBarPopular
    },
    watch: {
        "$i18n.locale"() {
            this.prepareUsersByMonth();
        },
    },
    methods:{
        getMetrics(){
            dashboardRequests.getAdminMetrics()
            .then(response => {
                if(response.status == 200){
                    let {data} = response
                    let {monthlySummary, generalSummary,approvedItineraries,pendingPaidConcierge,pendingPaidProvider} = data

                    this.monthSummary.pendingCommissions = monthlySummary.pending_commissions ?? monthlySummary.peding_commissions ?? 0;
                    this.monthSummary.pendingBookings = monthlySummary.approved_itineraries ?? monthlySummary.pending_itineraries ?? 0;
                    this.monthSummary.incomes = monthlySummary.total_billed_this_month;

                    this.generalSummary.conciergeUsers = generalSummary.concierge_amount;
                    this.generalSummary.providerUsers = generalSummary.provider_amount;
                    this.generalSummary.itinerariesGenerated = generalSummary.itineraries_generated;
                    this.generalSummary.bookingsGenerated = generalSummary.bookings_generated;
                    this.generalSummary.totalTransactions = generalSummary.total_billed;

                    this.pendingPaidConcierge = pendingPaidConcierge;
                    this.pendingPaidProvider = pendingPaidProvider;
                    this.approvedItineraries = approvedItineraries;

                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getChartMetrics(){
            dashboardRequests.getAdminChartMetrics(this.currentYear)
            .then(response => {
                if(response.status == 200){
                    let data = response.data
                    this.usersByMonth = data.users_by_month
                    this.incomesServices = data.incomes_services
                    this.prepareUsersByMonth()
                    this.prepareIncomesServices()
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        prepareIncomesServices(){
            let serviciosUnicos = [...new Set(this.incomesServices.map(item => item.name).filter(Boolean))];
            
            let datasets = serviciosUnicos.map((nombre, i) => {
                let data = new Array(12).fill(0);
                this.incomesServices.forEach(item => {
                    if (item.name === nombre) {
                        const indexMes = parseInt(item.month) - 1;
                        data[indexMes] += parseInt(item.service_amount);
                    }
                });

                return {
                    label: nombre,
                    data,
                    backgroundColor: `hsl(${i * 60}, 70%, 60%)`,
                };
            });

            this.chartData = datasets;
            console.log(this.chartData)
        },
        prepareUsersByMonth(){
            this.userChartData[0].label = this.$t("dashboard.auto.ingresos")
            this.userChartData[0].data = this.usersByMonth.map(user => {return user.user_amount})
        },  
        formatDate(dateString) {
            let date = new Date(dateString);
            if (Number.isNaN(date.getTime())) return this.$t("dashboard.auto.no_date");

            return new Intl.DateTimeFormat(this.currentLocale, {
                dateStyle: "medium",
                timeStyle: "short",
                timeZone: "UTC",
            }).format(date);
        },
        initData(){
            this.getMetrics()
            this.getChartMetrics()
        }
    },
    mounted(){
        console.log('entrando al dashboard admin')
        this.initData()
    }
}
</script>

<style lang="scss" scoped>

</style>
